import { useEffect } from 'react';
import Navbar from '../Components/navbar'
import Footer from '../Components/Footer';
import './enquiry.css'
export default function Enquiry() {

useEffect(() => {
       window.scrollTo(0, 0); // Scroll to the top of the page
     }, []);



  return (
    <>
    <Navbar/>
    
    <section id="Enquiry" className="enquiry-section">
  <h2 className="enquiry-title">Enquiry</h2>
  <form className="enquiry-form">
    <div className="form-grid">
      <input type="text" placeholder="Company Name" />
      <input type="text" placeholder="Person Name" />
      <input type="text" placeholder="Designation" />
      <input type="text" placeholder="Country Code (+91)" />
      <input type="text" placeholder="Mobile No" />
      <input type="email" placeholder="E-Mail" />
      <input type="text" placeholder="Address Line 1" />
      <input type="text" placeholder="Address Line 2" />
      <input type="text" placeholder="City" />
      <input type="text" placeholder="Pincode / Zipcode" />
      <input type="text" placeholder="Country" />
    </div>
    <textarea placeholder="Message" className="message-box"></textarea>

    {/* <div className="captcha-section">
      <label>Type the characters from the picture:</label>
      <img src="/captcha-demo.png" alt="Captcha" className="captcha-img" />
      <button type="button" className="refresh-btn">Refresh</button>
      <input type="text" placeholder="Type here characters from the picture" />
    </div> */}

    <button type="submit" className="submit-btn">SUBMIT</button>
  </form>
</section>

    
    
    <Footer/>
    </>
  )
}
